const Permission = {
  path: "",
  redirect: "/admin-management",
  name: "",
  component: {
    render(c) {
      return c("router-view");
    },
  },
  children: [
    {
      path: "/admin-management",
      redirect: "/admin-management",
      component: {
        render(c) {
          return c("router-view");
        },
      },
      name: "Admin",
      meta: {
        requiresAuth: true,
        activeUrl: "/admin-management",
        parent: "permission",

        lv: 1,
      },
      children: [
        {
          path: "",
          name: "",
          component: () => import("@/views/pages/managePermission"),
          meta: {
            requiresAuth: true,
            activeUrl: "/admin-management",
            parent: "permission",

            lv: 2,
          },
        },
        {
          path: "detail/:id",
          name: "Admin Detail",
          component: () => import("@/views/pages/managePermission/Detail.vue"),
          meta: {
            requiresAuth: true,
            isChildren: true,
            activeUrl: "/admin-management",
            parent: "permission",

            lv: 3,
          },
        },
      ],
    },
  ],
  meta: { requiresAuth: true },
};
export default Permission;
